import styled from "styled-components";
import { css } from "styled-components";

const getFontSizes = ([f1, l1], [f2, l2], mb) => css`
  font-size: ${f1}rem;
  line-height: ${l1}rem;
  margin-bottom: ${mb}rem;
`;
const h1Styles = css`
  ${getFontSizes([2, 2.25], [2.25, 2.5], 0)}
`;
const stylesMap = {
  h1: h1Styles,
  h2: getFontSizes([1.75, 2], [1.75, 2], 1.5),
  h3: getFontSizes([1.5, 1.75], [1.5, 1.75], 1.25),
  h4: getFontSizes([1.25, 1.5], [1.25, 1.5], 1.25),
  h5: getFontSizes([1, 1.5], [1, 1.5], 1),
  h6: getFontSizes([1, 1.5], [1, 1.5], 1),
};
const StyledHeader = styled.header`
  padding: 4rem 0 1rem 0;
  margin-bottom: 2rem;
  background-color: lightblue;
  border-bottom: 1px solid blue;
`;
const StyledHeading = styled.span`
  margin-top: 0;
  font-weight: bold;
  letter-spacing: -0.025em;
  ${({ as }) => stylesMap[as]}
  a {
    color: inherit;
  }
  ${({ styles }) => styles};
`;
const Heading = ({ children, level = "1", styles }) => {
  const heading = (
    <StyledHeading as={`h${level}`} styles={styles}>
      {children || "\xa0"}
    </StyledHeading>
  );
  return level === "1" ? <StyledHeader>{heading}</StyledHeader> : heading;
};
export default Heading;
